import React from 'react';
import './NewUserCard.css';

interface NewUserCardProps {
  username: string;
}

export const NewUserCard: React.FC<NewUserCardProps> = ({ username }) => {
  return (
    <div className="new-user-card">
      <div className="new-user-card-emoji">&#127793;</div>
      <h3 className="new-user-card-title">New to TradeMagic</h3>
      <p className="new-user-card-description">
        This trader is just getting started. Stats will appear after their first few trades.
      </p>
    </div>
  );
};

export default NewUserCard;
